import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../models/reduxState';
import { Attachments } from '../presentationalComponents/Attachments';
import { setAttachmentError, addAttachmentAction, deleteAttachmentAction } from '../reduxUpdater/actions/attachmentsActions';
import { dispatchGetDownloadAttachmentToken, dispatchGetUploadAttachmentToken, dispatchCancelUploadAttachment } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { getAttachmentsStyles } from '../styles/attachmentsStyles';

const mapStateToProps = (state: IAppState) => {
  return {
    attachmentsConfig: state.ContactState.AttachmentsState.attachmentsConfig,
    isUploadAttachmentInProgress: state.ContactState.AttachmentsState.isUploadAttachmentInProgress,
    isAttachmentActionAborted: state.ContactState.AttachmentsState.isAttachmentActionAborted,
    attachmentError: state.ContactState.AttachmentsState.attachmentError,
  };
};

const mapDispatchToProps = {
  dispatchGetUploadAttachmentToken,
  addAttachmentAction,
  deleteAttachmentAction,
  dispatchGetDownloadAttachmentToken,
  dispatchCancelUploadAttachment,
  setAttachmentError,
};

export const AttachmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(Attachments, getAttachmentsStyles));
